/**
 * ResultsList
 *
 * View that handles the interactions with the main map view. Communicates
 * via the OT.Events object when the user interacts with the list, i.e hovers
 * over a restaurant name
 *
 * NOTE: THIS FILE IS NOT USED
 *
 * @return {view}
 */

OT.createNS('OT.Redesign.Views.Results.Map.ResultsList');

OT.Redesign.Views.Results.Map.ResultsList = OT.Redesign.Views.Results.ResultsContainer.extend({
    el: '#search_results_map .results-list',

    template: 'Redesign/Search/Map/_ResultsList',

    events: {
        'mouseover .result': 'onResultMouseOver',
        'mouseout .result': 'onResultMouseOut'
    },

    initialize: function() {
        OT.Events.on('map-result:hovered-over', this.hightlightOnMap.bind(this));
        OT.Events.on('map-result:hovered-out', this.removeMapHighlight.bind(this));
    },

    beforeRender: function() {
        this.templateData = OT.Search.Data.get();
        return true;
    },

    onRender: function() {
        setTimeout(OT.Common.LazyLoadImages.loadAll);
    },

    updateResultsList: function() {
        this.additionalData = {
            clearLastFilter: !!(OT.Search.History.count() - 1)
        };

        this.render();
    },

    hightlightOnMap: function(e, index) {
        this.removeMapHighlight();
        this.$el.find('.result[data-id="' + index + '"]').first().addClass('hover');
    },

    removeMapHighlight: function() {
        this.$el.find('.hover').removeClass('hover');
    },

    onResultMouseOver: function(e) {
        OT.Events.fire('map-result:hovered-over', [$(e.currentTarget).data('id')]);
    },

    onResultMouseOut: function(e) {
        OT.Events.fire('map-result:hovered-out', [$(e.currentTarget).data('id')]);
    }

});
